import { memo, useContext, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MachineForm from './components/MachineForm';
import { useTranslation } from 'react-i18next';
import MachineOrders from './components/MachineOrders';
import GeneralData from './components/GeneralData';
import Attachments from './components/Attachments';
import { TabContext } from '../../../Context/TabContext';
import { formatDateBody, formatDateToDB } from '../../../../utils/FormatDate';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import toast from 'react-hot-toast';

const INITIAL_MACHINE_VALUE = {
  idMasine: 0,
  nazivMasine: '',
};
const INITIAL_CONTACT_VALUE = {
  kontaktOsoba: 'Demo',
  telefon: '(555) 123-6789',
  email: 'demo123@example.com',
};
const INITIAL_GENERAL_DATA = {
  idDok: 0,
  naslov: '',
  vrsteKvarova: '',
  idVrsteKvarova: 0,
  kodGreske: '',
  brojSatiRada: '',
  spindleHours: '',
  opisProblema: '',
  idStatusaMasine: 0,
  statusMasine: '',
  listaVrstaKvarova: [],
  IdKlijentAlat: 0,
  IdKlijentMasina: 0,
  nazivTipaMasine: '',
  nazivKlijentAlat: '',
  IdKlijentProizvod: 0,
  nazivKlijentProizvod: '',
  rokZavrsetka: '',
};

const ZahtevZaServis = ({
  save,
  handleSave,
  posalji,
  handlePosalji,
  handleDisablePosalji,
  handleDisableBtn,
}) => {
  const { getData } = useHttp('');
  const { t, i18n } = useTranslation();

  // #region[color2] ===== Prosledjivanje podataka sa druge stranice =====
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const machineLocal = dataLocal?.data ? dataLocal?.data : {};
  const [machineValue, setMachineValue] = useState(INITIAL_MACHINE_VALUE);
  // #endregion
  const [contactValue, setContactValue] = useState(INITIAL_CONTACT_VALUE);
  const [machineData] = useState([]);
  const [generalValue, setGeneralValue] = useState(INITIAL_GENERAL_DATA);
  const [attachmentData, setAttachmentData] = useState([]);
  const [machineForm, setMachineForm] = useState({});
  const [servisiData, setServisiData] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const localGeneral = dataLocal?.generalValue ? dataLocal?.generalValue : {};
  const localMachineValue = dataLocal?.machineValue
    ? dataLocal?.machineValue
    : {};
  const localMachinForm = dataLocal?.machineForm ? dataLocal?.machineForm : {};
  const localContactValue = dataLocal?.contactValue
    ? dataLocal?.contactValue
    : {};

  useEffect(() => {
    const tab = {
      type: 10010,
      title: 'Novi zahtev za servis',
      icon: 'fas fa-toolbox',
      generalValue: generalValue,
      machineValue: machineValue,
      machineForm: machineForm,
      contactValue: contactValue,
    };
    onTabChange(tab);
  }, [generalValue, machineValue, machineForm, contactValue]);
  useEffect(() => {
    if (Object.keys(localGeneral).length > 0) {
      setGeneralValue({
        ...localGeneral,
      });
    }
    if (Object.keys(localMachineValue).length > 0) {
      setMachineValue({
        ...localMachineValue,
      });
    }
    if (Object.keys(localMachinForm).length > 0) {
      setMachineForm({
        ...localMachinForm,
      });
    }
    if (Object.keys(localContactValue).length > 0) {
      setContactValue({
        ...localContactValue,
      });
    }
  }, []);

  const getMasina = async () => {
    const config = {
      method: 'POST',
      url: urls.VRATI_MASINU_ZA_ID,
      data: { id: machineLocal.idMasine, metadata: i18n.language },
    };
    const response = await getData(config);
    if (response) {
      setMachineForm(response);
      setMachineValue({
        idMasine: response.id,
        nazivMasine: response.sifra,
      });
      setContactValue({
        kontaktOsoba: response.kontaktOsoba,
        telefon: response.kontaktTelefon,
        email: response.email,
      });
    }
  };

  // setovanje podataka masine sa druge strane
  useEffect(() => {
    if (machineLocal?.fromChat) {
      setGeneralValue((curr) => {
        return {
          ...curr,
          opisProblema: machineLocal.opisProblema,
        };
      });
      getMasina();
    } else {
      console.log('podaci sa kartice masine', machineLocal);
      if (Object.keys(machineLocal).length > 0) {
        setMachineForm(machineLocal);
      }

      if (Object.keys(machineLocal).length > 0) {
        setMachineValue({
          idMasine: machineLocal.id,
          nazivMasine: machineLocal.sifra,
        });
      }
      if (Object.keys(machineLocal).length > 0) {
        setContactValue({
          kontaktOsoba: machineLocal.kontaktOsoba,
          telefon: machineLocal.kontaktTelefon,
          email: machineLocal.email,
        });
      }
    }
  }, []);
  useEffect(() => {}, []);

  // #region [color4] grid za prikaz zahteva
  const vratiServiseZaMasinu = async () => {
    const config = {
      url: urls.GET_ZAHTEVE_ZA_MASINU,
      method: 'POST',
      data: {
        Id: machineForm.id,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    setServisiData(response);
  };
  useEffect(() => {
    if (machineForm.id !== 0) {
      vratiServiseZaMasinu();
    }
  }, [machineForm.id, i18n.language]);
  const getEditData = async (id) => {
    // console.log(id);
    const config = {
      method: 'POST',
      url: urls.GET_ZAHTEVE_ZA_ID,
      data: {
        id: id,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    // console.log('Zahtevi za id', response);
    if (response.id > 0) {
      setGeneralValue(response);
      setMachineValue({
        idMasine: response.idMasine,
        nazivMasine: response.nazivMasine,
      });
      const listaFajlova = response?.listaDokumenata.map((item) => {
        return { ...item, name: item.vrednost };
      });
      setAttachmentData(listaFajlova);
    }
  };
  // #endregion

  // #region [color1] Cuvanje / Brisanje forme
  const handleSaveDocuments = async (id) => {
    const fd = new FormData();
    fd.append('IdVrsteDokOpste', 0);
    fd.append('objekat', 'sz');
    fd.append('IdObjekta', id);
    fd.append('NazivFajla', null);
    fd.append('IdJezika', 0);
    fd.append('Kategorija', null);
    fd.append('Datum', formatDateToDB(new Date()));
    fd.append('IdKorProm', +localStorage.idKorisnika);
    for (let i = 0; i < attachmentData.length; i += 1) {
      fd.append('Dokumenti', attachmentData[i]);
    }
    const config = {
      method: 'POST',
      url: urls.INSERT_DOKUMENTA,
      data: fd,
    };
    const result = await getData(config);
    console.log(result);
    // if (result) {
    // }
  };
  const saveZahtev = async () => {
    const config = {
      method: 'POST',
      url: generalValue.idDok > 0 ? urls.UPDATE_ZAHTEV : urls.INSERT_ZAHTEV,
      data: {
        id: generalValue.idDok,
        datum: formatDateBody(new Date()),
        idKorProm: +localStorage.getItem('idKorisnika'),
        idMasine: machineValue.idMasine,
        naslov: generalValue.naslov,
        opisProblema: generalValue.opisProblema,
        datumZatvaranja: null,
        idPrioriteta: null,
        kodGreske: generalValue.kodGreske,
        rokZavrsetka:
          generalValue.rokZavrsetka === '' ? null : generalValue.rokZavrsetka,
        brojSatiRada: +generalValue.brojSatiRada,
        opisProblemaDetaljan: generalValue.opisProblemaDetaljan,
        idStatusaMasine: generalValue.idStatusaMasine,
        listaVrstaKvarova: generalValue.listaVrstaKvarova,
        IdKlijentMasina: generalValue.IdKlijentMasina,
        IdKlijentAlat: generalValue.IdKlijentAlat,
        IdKlijentProizvod: generalValue.IdKlijentProizvod,
      },
    };
    const response = await getData(config);
    if (response?.idDok > 0) {
      handleSaveDocuments(response.idDok);
      setGeneralValue(INITIAL_GENERAL_DATA);
      vratiServiseZaMasinu();
      toast.success(t('dataAddedSuccessfully'));
    }
    // console.log('CUVANJE ZAHTEVA', response);
  };
  useEffect(() => {
    if (save) {
      // console.log('formvalues', generalValue);
      saveZahtev();
      handleSave(false);
    }
  }, [save]);

  const handleOpenDeleteDialog = (id) => {
    setGeneralValue({ ...generalValue, idDok: id });
    setOpenDeleteDialog(true);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_ZAHTEV,
      data: { id: generalValue.idDok },
    };
    const response = await getData(config);
    if (response > 0) {
      setGeneralValue(INITIAL_GENERAL_DATA);
      vratiServiseZaMasinu();
      setOpenDeleteDialog(false);
    }
  };
  // #endregion
  // #region [color5] Slanje zahteva

  const handleSlanjeZahteva = async () => {
    console.log('TO JE OVAJ SAVE1');
    const config = {
      method: 'POST',
      url: generalValue.idDok > 0 ? urls.UPDATE_ZAHTEV : urls.INSERT_ZAHTEV,
      data: {
        id: generalValue.idDok,
        datum: formatDateBody(new Date()),
        idKorProm: +localStorage.getItem('idKorisnika'),
        idMasine: machineValue.idMasine,
        naslov: generalValue.naslov,
        opisProblema: generalValue.opisProblema,
        datumZatvaranja: null,
        idPrioriteta: null,
        kodGreske: generalValue.kodGreske,
        brojSatiRada: +generalValue.brojSatiRada,
        opisProblemaDetaljan: generalValue.opisProblemaDetaljan,
        idStatusaMasine: generalValue.idStatusaMasine,
        listaVrstaKvarova: generalValue.listaVrstaKvarova,
        poslato: true,
        datumSlanja: formatDateBody(new Date()),
        rokZavrsetka:
          generalValue.rokZavrsetka === '' ? null : generalValue.rokZavrsetka,
        IdKlijentMasina: generalValue.IdKlijentMasina,
        IdKlijentAlat: generalValue.IdKlijentAlat,
        IdKlijentProizvod: generalValue.IdKlijentProizvod,
      },
    };
    const response = await getData(config);
    if (response?.idDok > 0) {
      handleSaveDocuments(response.idDok);
      setGeneralValue(INITIAL_GENERAL_DATA);
      vratiServiseZaMasinu();
    }
  };
  const handlePosaljiZahtev = async (item) => {
    console.log('TO JE OVAJ SAVE2', item);
    const config = {
      method: 'POST',
      url: item.idDok > 0 ? urls.UPDATE_ZAHTEV : urls.INSERT_ZAHTEV,
      data: {
        id: item.idDok,
        datum: formatDateBody(new Date()),
        idKorProm: +localStorage.getItem('idKorisnika'),
        idMasine: machineValue.idMasine,
        naslov: item.naslov,
        opisProblema: item.opisProblema,
        datumZatvaranja: null,
        idPrioriteta: null,
        kodGreske: item.kodGreske,
        brojSatiRada: +item.brojSatiRada,
        opisProblemaDetaljan: item.opisProblemaDetaljan,
        idStatusaMasine: item.idStatusaMasine,
        listaVrstaKvarova: item.listaVrstaKvarova,
        poslato: true,
        datumSlanja: formatDateBody(new Date()),
        IdKlijentMasina: item.IdKlijentMasina,
        IdKlijentAlat: item.IdKlijentAlat,
        IdKlijentProizvod: item.idKlijentProizvod,
      },
    };
    const response = await getData(config);
    if (response?.idDok > 0) {
      handleSaveDocuments(response.idDok);
      setGeneralValue(INITIAL_GENERAL_DATA);
      vratiServiseZaMasinu();
    }
  };
  useEffect(() => {
    if (posalji) {
      handleSlanjeZahteva();
      handlePosalji(false);
    }
  }, [posalji]);

  useEffect(() => {
    if (generalValue.poslato) {
      handleDisableBtn({ id: 10010, disabled: true });
      handleDisablePosalji(true);
    } else {
      handleDisableBtn({ id: 10010, disabled: false });
      handleDisablePosalji(false);
    }
  }, [generalValue]);

  // #endregion

  console.log(machineForm.tipMasine);

  // #region [color3] ===== Accordion ===
  const [panels, setPanels] = useState([
    // zaglavlje
    {
      id: 'machine',
      // title:
      //   machineForm.tipMasine === ''
      //     ? ''
      //     : machineForm.tipMasine === 'Robot'
      //     ? 'Robot'
      //     : 'Alat',

      expanded: true,
      component: memo(MachineForm),
    },
    // Opsti podaci forma
    {
      id: 'generalData',
      title: 'generalData',
      expanded: true,
      component: memo(GeneralData),
    },
    // kacenje dokumenta
    {
      id: 'attachments',
      title: 'attachments',
      expanded: true,
      component: memo(Attachments),
    },
    // grid za prikaz zahteva
    {
      id: 'machineOrders',
      title: 'Zahtevi za servis',
      expanded: true,
      component: memo(MachineOrders),
    },
  ]);

  const handleChangeExpand = (index) => {
    setPanels((prevPanels) =>
      prevPanels.map((panel, i) =>
        i === index ? { ...panel, expanded: !panel.expanded } : panel,
      ),
    );
  };
  // #endregion
  return (
    <div>
      {panels.map((panel, index) => (
        <Accordion
          key={panel.id}
          expanded={panel.expanded}
          onChange={() => handleChangeExpand(index)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index + 1}-content`}
            id={`panel${index + 1}-header`}
          >
            <strong>{t(panel.title)}</strong>
            {/* <strong>{panel.title}</strong> */}
          </AccordionSummary>
          <AccordionDetails>
            {index === 0 && (
              <panel.component
                machineValue={machineValue}
                setMachineValue={setMachineValue}
                machineData={machineData}
                contactValue={contactValue}
                generalValue={generalValue}
                machineType={machineForm?.tipMasine}
              />
            )}

            {index === 1 && (
              <panel.component
                generalValue={generalValue}
                setGeneralValue={setGeneralValue}
                tipId={
                  machineForm?.idTipaMasine > 0 ? machineForm?.idTipaMasine : 0
                }
                tipString={machineForm?.tipMasine || ''}
                idMasine={
                  machineValue?.idMasine > 0 ? machineValue?.idMasine : 0
                }
              />
            )}
            {index === 2 && (
              <panel.component
                setAttachmentData={setAttachmentData}
                attachmentData={attachmentData}
              />
            )}
            {index === 3 && (
              <panel.component
                data={servisiData}
                getEditData={getEditData}
                handleOpenDeleteDialog={handleOpenDeleteDialog}
                handlePosaljiZahtev={handlePosaljiZahtev}
              />
            )}
          </AccordionDetails>
        </Accordion>
      ))}
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default ZahtevZaServis;
